export const list = {
  realname: {
    name: '姓名',
    key: 'realname',
    check: false
  },
  job_number: {
    name: '工号',
    key: 'job_number'
  },
  depart_id: {
    name: '所属部门',
    key: 'depart_id'
  },
  job_title: {
    name: '职位',
    key: 'job_title'
  },
  phone: {
    name: '电话',
    key: 'phone'
  },
  working_status: {
    name: '状态',
    key: 'working_status'
  },
  email: {
    name: '邮箱',
    key: 'email'
  },
  // usertype: {
  //   name: '用户类型',
  //   key: 'usertype'
  // },
  // username: {
  //   name: '员工名称',
  //   key: 'username'
  // },
  // is_secret: {
  //   name: '是否保密',
  //   key: 'is_secret'
  // }
};
